module.exports = __webpack_public_path__ + "img/pobednikW.ec4c5c52.png";